import { Collapse, UncontrolledCollapse, Button, CardBody, Card } from 'reactstrap'
import Lazyload from 'react-lazy-load'
import {Trans, useTranslation, useI18next} from 'gatsby-plugin-react-i18next';
import { useLocation } from '@reach/router';

const GlobalEmployeeEngagement = () => {
    const location = useLocation();
    const { pathname } = location;
    const { t } = useTranslation();
    return (
    <>
        <section className="bg-dark multi-activity hero-bg position-relative section-pdn pt-8 soln-hero wrp-1">
            <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
                <div className="col-12">
                    <h1 className="font-weight-semibold hero-heading text-center no-br">
                    <Trans>Reward Wellness to Foster <br/>Healthy Habits</Trans>
                    </h1>
                    <p className="hero-para font-weight-normal text-center no-br">
                    <Trans>Motivate and celebrate healthy behaviors with tailored <br/>rewards and recognition.</Trans>
                    </p>
                    <div className="pl-0 pr-0 col-12 mtb25 d-flex justify-content-center align-items-center">
                        <a href={t(`/request-demo/`)} className="vfitcompanycta arrowbtn-img">
                            <Trans>Book a Demo</Trans>
                        </a>
                    </div>
                </div>
            </div>
        </section>
        <section className="position-relative pb-0 vfitsoln wrp-2">
            <div className="feat_box sect-white-col-2 feat_pb0 mb-0">
                <div className="d-flex m-d-block container custom_container p0">
                    <div className="col-12 col-md-6 p-0">
                        <div className="col-12 p-0 pt-5">
                            <h2 className='font-weight-semibold py-2 section-heading pt-0 pt-md-5 mt-0 mt-md-5 no-br green-text'><Trans>Want to <span>recognize</span> <br/>top performers and celebrate milestones?</Trans></h2>
                            <p className='section-para font-weight-normal no-br'><Trans>From leaderboards to customized rewards, <br/>celebrate every achievement with Vantage Fit.</Trans></p>
                        </div>
                    </div>
                    <div className='cta-img'>
                        <div className='d-flex justify-content-center'>
                            <img loading="lazy" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/v1698821739/VantageFit/2023/Wellness_Rewards_Program-pain-point.webp`)} alt="Want to recognize top performers and celebrate milestones?" width="600" height="795"/>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="position-relative pl-0 pr-0">
            <div className="">
                <h2 className="section-heading section-heading-top font-weight-semibold text-center"><Trans>Unlock Your Best Self with Wellness Rewards!</Trans></h2>
                <div className="">
                    <div className="feat_box sect-white-col-2 shadow active_challenge pt-5 pb-5">
                        <div className="container custom_container d-flex m-d-block p-0 justify-content-between align-items-center">
                            <div className="col-12 col-md-5">
                                <div className="col-12">
                                    <h2 className='font-weight-semibold py-2 section-heading'><Trans>Rewards & Redemption</Trans></h2>
                                    {/* <p className='section-para font-weight-normal'>Rewards designed to inspire proactive engagement in wellness and cultivate lasting healthy habits.</p> */}
                                    <div>
                                        <ul className='greenTick position-relative' style={{minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Design incentives to encourage active participation in wellness activities.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Motivate users with rewards that foster lasting and healthy habits.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Encourage a sustained commitment to wellness through thoughtful rewards.</Trans></p>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-md-7 cta-img'>
                                <div className='d-flex justify-content-center'>
                                    <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/v1699595038/VantageFit/2023/Wellness_Rewards_Program-Rewards_Redemption.webp`)} loading='lazy' alt="Rewards & Redemption" width="751" height="600"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="feat_box sect-white-col-2 shadow active_challenge">
                        <div className="container custom_container d-flex m-d-block p-0 justify-content-between align-items-center">
                            <div className="col-12 col-md-5">
                                <div className="col-12">
                                    <h2 className='font-weight-semibold py-2 section-heading'><Trans>Points Based Rewards</Trans></h2>
                                    {/* <p className='section-para font-weight-normal'>Honor milestones and efforts to enhance motivation with our Vantage Fit points.</p> */}
                                    <div>
                                        <ul className='greenTick position-relative' style={{minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Acknowledge accomplishments and efforts through Vantage Fit points.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Boost motivation by rewarding milestones with Vantage Fit points.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Use points to recognize and incentivize ongoing achievements.</Trans></p>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-md-7 cta-img'>
                                <div className='d-flex justify-content-center'>
                                    <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/v1703073862/VantageFit/2023/Wellness_Rewards_Program-Points_Based_Rewards.webp`)} loading='lazy' alt="Points Based Rewards" width="682" heigth="600"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="feat_box sect-white-col-2 shadow active_challenge">
                        <div className="container custom_container d-flex m-d-block p-0 justify-content-between align-items-center">
                            <div className="col-12 col-md-5">
                                <div className="col-12">
                                    <h2 className='font-weight-semibold py-2 section-heading'><Trans>Diverse Reward Redemption</Trans></h2>
                                    {/* <p className='section-para font-weight-normal'>From Gift Cards and Merchandise to unforgettable Experiences - redeem as you desire!</p> */}
                                    <div>
                                        <ul className='greenTick position-relative' style={{minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Redeem earned rewards for Gift Cards, Merchandise, or memorable Experiences.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Enjoy the flexibility of choosing rewards based on personal preferences.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>From tangible items to unique experiences, the choice is yours!</Trans></p>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-md-7 cta-img'>
                                <div className='d-flex justify-content-center'>
                                    <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/v1703073861/VantageFit/2023/Wellness_Rewards_Program-Diverse_Reward_Redemption.webp`)} loading='lazy' alt="Diverse Reward Redemption"  width="547" heigth="600"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="feat_box sect-white-col-2 shadow active_challenge">
                        <div className="container custom_container d-flex m-d-block p-0 justify-content-between align-items-center">
                            <div className="col-12 col-md-5">
                                <div className="col-12">
                                    <h2 className='font-weight-semibold py-2 section-heading'><Trans>Milestone Celebrations</Trans></h2>
                                    {/* <p className='section-para font-weight-normal'>Celebrate individual and team milestones with special recognitions.</p> */}
                                    <div>
                                        <ul className='greenTick position-relative' style={{minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Commemorate personal achievements with special recognitions.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Acknowledge and celebrate collective milestones as a team.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Elevate the spirit by giving deserved attention to individual and team accomplishments.</Trans></p>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-md-7 cta-img'>
                                <div className='d-flex justify-content-center'>
                                    <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/v1703073863/VantageFit/2023/Wellness_Rewards_Program-Milestone_Celebration.webp`)} loading='lazy' alt="Milestone Celebrations" width="477" heigth="600"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="gray-gradient-bg section-pdn-1">
            <div className="container custom_container mx-auto relative">
                <div className="px-5">
                    <h2 className="section-heading text-center pt-0">
                    <Trans>Real people, real results</Trans>
                    </h2>
                    <p className="col-12 sub-para text-center f-400 mt-0 mb-5 pb-5">
                    <Trans>Vantage Fit speaks for itself, but our
                        customer reviews speak even louder.</Trans>
                    </p>
                    <div className="col-lg-12 testimonialcarousel d-none d-md-flex mb-0 p-5">
                        <div className="testi_profile">
                            <div className="testi_profile_image"><img src="https://res.cloudinary.com/vantagecircle/image/upload/v1700137313/VantageFit/2023/Beth_Kalbach.webp" alt="Beth Kalbach" className="max-w lozad" width="218" height="218" loading="lazy"/></div>
                            <div className="testi_profile_name p-4">
                                <h3 className="font-weight-bold text-center text-lg-left text-white mb-0">Beth Kalbach</h3>
                                <p className="font-weight-light text-center text-lg-left text-white mb-0">Marinus Pharma</p>
                            </div>
                        </div>
                        <div className="d-flex flex-column flex-lg-row justify-content-around align-items-center ">
                            <div className="col-12 col-md-11 d-flex flex-column">
                                <p className="section-para text-center text-lg-left mb-0"><Trans>The app worked out great, it was straight forward and easy to use.</Trans></p>
                            </div>
                        </div>
                    </div>
                    <div className="d-md-none d-block p-3" style={{ background: 'white', boxShadow: '1px 0px 20px rgba(0,0,0,0.3)', borderRadius: '25px' }}>
                        <div className="p-2" style={{ background: '#1d2227', borderRadius: '40px', display: 'grid', justifyContent: 'center' }}>
                            <img style={{ marginLeft: '0.5rem !important', marginTop: '0.5rem', marginBottom: '1rem' }} src="https://res.cloudinary.com/vantagecircle/image/upload/v1700218240/VantageFit/2023/Beth_Kalbach.webp" alt="Jayson Ho" className="mx-auto" width="218" height="218" loading="lazy"/>
                            <h3 className="font-weight-bold text-center text-white mb-0">Beth Kalbach</h3>
                            <p className="font-weight-light text-center text-white my-3">Marinus Pharma</p>
                        </div>
                        <p className="section-para text-center text-lg-left my-4"><Trans>The app worked out great, it was straight forward and easy to use.</Trans></p>
                    </div>
                </div>
            </div>
        </section>

        <section className="position-relative section-pdn-1 pl-0 pr-0">
            <div className="logo-container">
                <h2 className="section-heading mb-5 no-br clr50">FAQ</h2>
                <div id="accordion" className="">
                    <Card>
                        <Button id="faq1">
                        <Trans>How can we reward employees for their wellness activities?</Trans>
                        </Button>
                        <UncontrolledCollapse toggler="#faq1">
                            <CardBody>
                            <Trans>Employees receive rewards for their wellness activities through automated badges and certifications, with multiple badge categories corresponding to different levels of achievement.</Trans>

                            </CardBody>
                        </UncontrolledCollapse>
                    </Card>
                    <Card>
                        <Button id="faq2">
                        <Trans>Are there any options for monetary rewards available within Vantage Fit?</Trans>
                        </Button>
                        <UncontrolledCollapse toggler="#faq2">
                            <CardBody>
                            <Trans>Vantage Fit provides Fit points based on completed activities, which can be utilized to redeem gift cards across over 20 categories. It's important to note that these points cannot be converted into cash; instead, they can be used exclusively for purchasing gift cards.</Trans>
                            </CardBody>
                        </UncontrolledCollapse>
                    </Card>
                    <Card>
                        <Button id="faq3">
                        <Trans>What is the value of a Fit point in Vantage Fit?</Trans>
                        </Button>
                        <UncontrolledCollapse toggler="#faq3">
                            <CardBody>
                            <Trans>Each Fit Point equals 1 Rupee in Vantage Fit.</Trans>
                            </CardBody>
                        </UncontrolledCollapse>
                    </Card>
                </div>
            </div>
        </section>

        <section className="wrp-btm ctabtm multi-activity hero-bg position-relative section-pdn-1 pt-8 feat_testi brad0">
            <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
                <div className="col-12">
                    <h2 className="font-weight-semibold section-heading text-center no-br">
                    <Trans>Boost Wellness Participation with <br/>Rewarding Experiences!</Trans>
                    </h2>
                    <p className="sub-para font-weight-normal text-center mb-5">
                    <Trans>Discover the power of incentives with Vantage Fit.</Trans>
                    </p>
                    <div className="pl-0 pr-0 col-12 mtb25 d-flex justify-content-center align-items-center">
                        <a href={t(`/request-demo/`)} className="vfitcompanycta arrowbtn-img">
                            <Trans>Book a Demo</Trans>
                        </a>
                    </div>
                </div>
            </div>
        </section>

    </>
  )
}

export default GlobalEmployeeEngagement
